module.exports = __webpack_public_path__ + "static/herebedragons-7a063b2e15fe7489ccdb73c5f41224de.webp";